// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1vr1e","content":"Consent_content__3u3Ip","footer":"Consent_footer__2VmN5"};